import * as http from '@/util/http'
import { z } from 'zod'

export const ArticleSchema = z.object({
  id: z.number().int(),
  title: z.string(),
  content: z.any(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
})

export type Article = z.infer<typeof ArticleSchema>

export async function fetchUserArticles(): Promise<Article[]> {
  const resp = await http.get<Article[]>('/api/v1/user/article')
  return resp.data
}
